import * as React from 'react';
import { useFormState } from 'react-final-form';
import { useTranslator } from '@gandi/translate';
import { Button, Tooltip, TooltipContainer } from '@gandi/ui';
import { useReadOnly } from '../formUtils/readOnly';
import { jsx as _jsx } from "react/jsx-runtime";
const SubmitButton = props => {
  const {
    __
  } = useTranslator();
  const {
    valid,
    submitting,
    dirtySinceLastSubmit
  } = useFormState();
  const {
    readOnly
  } = useReadOnly();
  const isFormReady = readOnly && (valid || dirtySinceLastSubmit);
  return /*#__PURE__*/_jsx(TooltipContainer, {
    id: "submit-template-form-tooltip",
    enabled: !isFormReady,
    renderReference: getReferenceProps =>
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    _jsx(Button, {
      type: "submit",
      loading: submitting,
      disabled: !isFormReady,
      ...props,
      ...getReferenceProps()
    }),
    children: getTooltipProps => /*#__PURE__*/_jsx(Tooltip, {
      ...getTooltipProps(),
      children: __('You need to complete sections')
    })
  });
};
export default SubmitButton;